import React, {useEffect} from 'react';
import Mural from '../components/Mural';
import Cards from '../components/Cards';
import BackgroundImage from '../components/BackgroundImage';
import Accordion from '../components/Accordion';
import ContactSection from '../components/ContactSection';
import '../App.css';
import Sobre from '../components/Sobre';

function Home() {

  useEffect(() => {
    window.scrollTo(0, 0);

    // Adicionar o Google Analytics
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-ETQFHX8NN9';
    gtagScript.async = true;
    document.head.appendChild(gtagScript);

    const gtagConfigScript = document.createElement('script');
    gtagConfigScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-ETQFHX8NN9');
    `;
    document.head.appendChild(gtagConfigScript);

    return () => {
        // Cleanup quando o componente for desmontado (opcional)
        document.head.removeChild(gtagScript);
        document.head.removeChild(gtagConfigScript);
    };

  }, []);

  return (
    <div>
      <section id="home">
        <Mural />
      </section>

      <Cards />
      <BackgroundImage />

      <section id="about">
        <Sobre/>
      </section>
      <Accordion />
      <section id="contact">
        <ContactSection />
      </section>
    </div>
  );
}

export default Home;
